export default "__VITE_ASSET__Cxky$wGz__"